import React, { useState, useContext } from 'react';
import 'antd/dist/antd.css';
import { Row, Col, message, Modal } from 'antd';

import button_arrow_left from 'images/button_arrow_left.svg';

import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import FormulaBuilder from './FormulaBuilder';
import keyBy from 'lodash/keyBy';

import TransformConditional from './TransformConditional';

import { updateOrCreateColumn } from 'services/project';

import { _l } from 'lib/utils';
import NumericalKeyboard from './components/NumericalKeyboard';

import { TransformContext } from './TransformContext';
import TransformationDropdownMenu from './components/TransformationDropdownMenu';
import icon_right from 'images/icon_right_pop_up.svg';
import version_pro from 'images/version_pro.svg';

import moment from 'moment';


import icon_x from 'images/icon_x_pop_up.svg';
import icon_y from 'images/icon_y_pop_up.svg';
import econometrica_logo_popup from 'images/eco_logo_popup.svg';
import { AppContext } from 'context/AppContext';


const SecondSiderTransform = (props) => {
    let tContext = useContext(TransformContext);
    let appContext = useContext(AppContext);

    const [numericalName, setNumericalName] = useState('Numerical name');
    const [renameNumerical, setRenameNumerical] = useState('Numerical name');
    const [showModalGoPro, setShowModalGoPro] = useState(false);

    const handleNumericalClick = () => {
        props.setTransformVisibleButton('numerical');
    };

    const handleConditionalClick = () => {
        props.setTransformVisibleButton('conditional');
    };

    const handleAsideVisible = () => {
        appContext.setAsideIsVisible(!appContext.asideIsVisible);
    };

    const handleApply = () => {
        let formula = [];
        let items = [...tContext.formulaItems];

        let formulaStack = [];

        for (let item in items) {
            let formulaItem = items[item]['start'];
            if (items[item].hasOwnProperty('end'))
                formulaStack.push(items[item]);

            if (items[item]['type'] == 'p-end') {
                formulaItem = formulaStack.pop();
                formulaItem = formulaItem['end'];
            }

            formula.push(formulaItem);
        }

        let currentProject = localStorage.getItem('activeProject');
        const data = {
            project: currentProject,
            user_formula: formula.join(''),
            user_formula_json: items,
            trans_type: 'numerical',
            name: renameNumerical
        };

        let columnId = '';

        updateOrCreateColumn(data, columnId)
            .then((res) => {
                if (res.status === 201) {
                    

                    // if (props.refTable.current !== undefined) {
                    //     setTimeout(() => {
                    //         props.refTable.current.children[0].childNodes[0].children[0].children[0].children[0].children[1].scrollBy(
                    //             {
                    //                 top: 0,
                    //                 left: 100000,
                    //                 behavior: 'smooth'
                    //             }
                    //         );
                    //     }, 1000);
                    // }

                    // props.setRerenderTable(!props.rerenderTable);
                    
                    const rerenderTable = async()=>{
                        console.log(`rerenderTable`)
                        let result = await props.setRerenderTable(!props.rerenderTable);
                        return result
                    }

                    const scrolltoTheEndOfTable = async()=>{
                        let reportTime = moment().format('HH:mm:ss');
                        await new Promise((res, rej)=>{
                            // console.log(`scrolltoTheEndOfTable`, res, rej)
                            console.log( `Get time from created 201: ${reportTime}` )

                            
                            if (props.refTable.current !== undefined) {
                                setTimeout(() => {
                                    // console.log("CONDITIONAL")
                                    // console.log(props.refTable.current.children[0].childNodes[0].children[0].children[0].children[0].children[1].offsetWidth)
                                    // console.log(props.refTable.current)
                                    // console.log(props.refTable.current.children[0].childNodes[0].children[0].children[0].children[0].children[1].children[0].children[0].children[1].children[0].offsetWidth)
                                    props.refTable.current.children[0].childNodes[0].children[0].children[0].children[0].children[1].scrollBy(
                                        {
                                            top: 0,
                                            left: 100000,
                                            behavior: 'smooth'
                                        }
                                    );
                                }, 2500);
                            }
                        })
                    }

                    // scrolltoTheEndOfTable()
                    // rerenderTable();

                    const render = async()=>{
                        const rereTable = await rerenderTable()
                        const scrollEndTAble = await scrolltoTheEndOfTable()
                        return {rereTable, scrollEndTAble}
                    }
                    render()                                                         
               
                }

                if (res.status === 200) {
                    props.setColumnDbId(res.id);
                } else if (res.status === 500) {
                } else if (res.status === 400) {
                } else {
                    ///setLoadingSpinner(false);
                }
            })
            
            .catch((error) => {
                const res = error.response;

                if (res.status == 400) {
                    const messages = res.data.message;
                    console.log(`messages:`,  res)
                    for (let item in messages) {
                    console.log(`messages:`, messages[item])

                        message.error(messages[item]);
                    }
                }

                console.log('error 400', error, error.response, error.message);
            });

        setRenameNumerical('Numerical name');
        handleClear()
        props.setRerenderTable(!props.rerenderTable);
    };

    const handleClear = () => {
        tContext.setFormulaItems([]);
    };

    const handleConditionalName = (text) => {
        props.setConditionalName(`${text}`);
    };

    if (
        props.conditionalName === 'Condition name' &&
        props.conditionalItems[0].condition[0].var_a !== ''
    ) {
        let columnIndex = props.conditionalItems[0].condition[0].var_a;
        let tableColumn = keyBy(props.tableColumn, 'dataIndex');
        let columnName = tableColumn[columnIndex].columnName.split(': ')[1];
        if (columnName) props.setConditionalName(`Recoded ${columnName}`);
        else
            props.setConditionalName(
                `Recoded ${tableColumn[columnIndex].columnName.split(': ')[0]}`
            );
    }

    const tableColumnsDisplay = (tableColumn) => {
        let columnList = [];
        for (let columnIndex in tableColumn) {
            if (tableColumn[columnIndex]['type'] === 'NUMBER') {
                columnList.push(
                    <li
                        key={columnIndex}
                        onClick={() => {
                            props.handleSetVariableFormula(
                                tableColumn[columnIndex].dataIndex
                            );
                        }}
                    >
                        {tableColumn[columnIndex].columnName}
                    </li>
                );
            }
        }

        return columnList;
    };

    return (
        <>
            <div
                style={{
                    width: 270,
                    height: '100vh',
                    backgroundColor: '#407cb1',
                    transition: 'width 5s',
                    padding: '20px 0px 20px 20px',
                    color: 'white',
                    position: 'sticky',
                    top: 0,
                    zIndex: 10
                }}
            >
                <img
                    alt=""
                    onClick={handleAsideVisible}
                    src={button_arrow_left}
                    style={{
                        position: 'absolute',
                        top: '50%',
                        right: '-16px',
                        zIndex: 100
                    }}
                />
                {/* {appContext.defaults.sub_is_active ? ( */}
                <div>
                    <div
                        className="secondsidertransform"
                        style={{ display: 'flex' }}
                    >
                        {props.transformVisibleButton === 'numerical' ? (
                            <Row onClick={(event) => event.stopPropagation()}>
                                <Col
                                    className="analysis-container-box"
                                    style={{
                                        // display: 'flex',
                                        // alignItems: 'center',
                                        textOverflow: 'ellipsis',
                                        overflow: 'hidden',
                                        width: '210px',
                                        /* height: 1.2em; */
                                        whiteSpace: 'nowrap',
                                    }}
                                >
                                    {/* {renameNumerical.length > 19
                                        ? renameNumerical.substring(0, 19) +
                                          '...'
                                        : renameNumerical} */}
                                        {renameNumerical}
                                </Col>
                                <div className={props.className}>
                                    <TransformationDropdownMenu
                                        rename={renameNumerical}
                                        setNewName={setRenameNumerical}
                                    />
                                </div>
                            </Row>
                        ) : (
                            <Row onClick={(event) => event.stopPropagation()}>
                                <Col
                                    className="analysis-container-box"
                                    style={{
                                        // display: 'flex',
                                        // alignItems: 'center',
                                        textOverflow: 'ellipsis',
                                        overflow: 'hidden',
                                        width: '210px',
                                        /* height: 1.2em; */
                                        whiteSpace: 'nowrap',
                                    }}
                                >
                                    {props.conditionalName}
                                </Col>

                                <TransformationDropdownMenu
                                    rename={props.conditionalName}
                                    setNewName={props.setConditionalName}
                                />
                            </Row>
                        )}
                    </div>

                    <hr
                        style={{
                            marginTop: 0,
                            background: '#fff',
                            opacity: '1',
                            width: '230px'
                        }}
                    />

                    <div
                        style={{
                            display: 'flex',
                            flexDirection: 'row',
                            marginBottom: 20,
                            alignItems: 'center',
                            position: 'relative'
                        }}
                    >
                        <div
                            style={{ display: 'flex' }}
                            onClick={() => {
                                handleNumericalClick();
                            }}
                            className={`transform-type-numerical ${
                                props.transformVisibleButton === 'numerical'
                                    ? 'transform-type-active'
                                    : 'transform-type-inactive'
                            }`}
                        >
                            Numerical
                        </div>
                        <div
                            style={{
                                padding: '10px 0px',
                                borderLeft: '1px solid white'
                            }}
                        ></div>
                        <div
                            style={{ display: 'flex' }}
                            onClick={() => {
                                handleConditionalClick();
                            }}
                            className={`transform-type-conditional ${
                                props.transformVisibleButton === 'conditional'
                                    ? 'transform-type-active'
                                    : 'transform-type-inactive'
                            }`}
                        >
                            Conditional
                            {!appContext.defaults.sub_is_active ? (
                                <img
                                    src={version_pro}
                                    style={{
                                        position: 'absolute',
                                        top: '-8px',
                                        right: '20px'
                                    }}
                                />
                            ) : null}
                        </div>
                    </div>

                    {props.transformVisibleButton === 'numerical' ? (
                        <div id="calculator">
                            <DndProvider backend={HTML5Backend}>
                                <FormulaBuilder
                                    formulaItems={tContext.formulaItems}
                                    setFormulaItems={tContext.setFormulaItems}
                                />
                            </DndProvider>

                            <ul>{tableColumnsDisplay(props.tableColumn)}</ul>

                            <NumericalKeyboard />

                            <div
                                className="transform-conditional-card-buttons"
                                style={{ paddingRight: 20, marginTop: 20 }}
                            >
                                {/* <div
                                    className="button-clear-all"
                                    onClick={() => {
                                        handleClear();
                                    }}
                                >
                                    CLEAR ALL
                                </div> */}
                                <div
                                    style={{ width: '100%' }}
                                    className="button-create"
                                    onClick={() => {
                                        handleApply();
                                    }}
                                >
                                    CREATE
                                </div>
                            </div>
                        </div>
                    ) : appContext.defaults.sub_is_active ? (
                        <TransformConditional
                            conditionalItems={props.conditionalItems}
                            setConditionalItems={props.setConditionalItems}
                            tableColumn={props.tableColumn}
                            handleConditionalName={handleConditionalName}
                            conditionalName={props.conditionalName}
                            setConditionalName={props.setConditionalName}
                            setRerenderTable={props.setRerenderTable}
                            rerenderTable={props.rerenderTable}
                            rawProjectData={props.rawProjectData}
                            conditionalTransform={props.conditionalTransform}
                            setConditionalTransform={
                                props.setConditionalTransform
                            }
                            columnDbId={props.columnDbId}
                            setColumnDbId={props.setColumnDbId}
                            numericalName={numericalName}
                            setNumericalName={setNumericalName}
                        />
                    ) : (
                        <div
                            className="go-pro-button-transform"
                            onClick={() => {
                                setShowModalGoPro(true);
                            }}
                        >
                            go pro
                        </div>
                    )}
                </div>
            </div>

            <Modal
                className="custom-modal-go-pro"
                title=""
                visible={showModalGoPro}
                // onOk={handleOkPreloaded}
                onCancel={() => {
                    setShowModalGoPro(false);
                }}
                footer={null}
                closable={false}
                bodyStyle={{ minHeight: 574 }}
                width={700}
            >
                <div className="header">
                    <div className="title">Go Pro for full functionality.</div>
                </div>
                <div className="body">
                    <div className="container1">
                        <div className="con-header">
                            <img src={econometrica_logo_popup} />
                        </div>
                        <div className="hr"></div>
                        <div className="con-body">
                            <div className="desc-bold">Projects</div>
                            <div className="desc-bold">Transformation</div>
                            <div className="desc-bold">Analysis</div>
                            <div className="desc">Scatterplot</div>
                            <div className="desc">Regression</div>
                            <div className="desc">Koyck</div>
                        </div>
                    </div>
                    <div className="container2">
                        <div className="con-header">
                            <div className="title-bold">Lite</div>
                            <div className="title">FREE</div>
                        </div>
                        <div className="hr"></div>
                        <div className="con-body">
                            <div className="ul">
                                <div className="li">30 projects</div>
                                <div className="li">Numerical</div>
                                <div className="li">Univariate</div>
                                <div className="li">
                                    <img src={icon_x} />
                                </div>
                                <div className="li">
                                    <img src={icon_x} />
                                </div>
                                <div className="li">
                                    <img src={icon_x} />
                                </div>
                            </div>
                            <div
                                onClick={() => {
                                    setShowModalGoPro(false);
                                }}
                                className="btn-go-back"
                            >
                                Go Back to Lite
                            </div>
                        </div>
                    </div>
                    <div className="container3">
                        <div className="con-header">
                            <div className="title-bold">PRO</div>
                            <div className="title">
                                <span className="dolar">$</span>85
                                <span className="year">/ year</span>
                            </div>
                        </div>
                        <div className="hr"></div>
                        <div className="con-body">
                            <div className="ul">
                                <div className="li">Unlimited</div>
                                <div className="li">
                                    Numerical & Conditional
                                </div>
                                <div className="li">Uni & Multivariate</div>
                                <div className="li">
                                    <img src={icon_y} />
                                </div>
                                <div className="li">
                                    <img src={icon_y} />
                                </div>
                                <div className="li">
                                    <img src={icon_y} />
                                </div>
                            </div>
                            <div
                                className="btn-go-pro"
                                onClick={() => {
                                    setShowModalGoPro(false);
                                    appContext.setMainUserDetailsDrawerIsVisible(
                                        true
                                    );
                                }}
                            >
                                Go Pro <img src={icon_right} />
                            </div>
                        </div>
                    </div>
                </div>
            </Modal>
        </>
    );
};

export default SecondSiderTransform;
